import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20d79537"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "alert alert-warning"
}

import { computed, ref } from 'vue'
import { PotentialMember } from './FamilyGroupMemberManager'
import { InvitationResult } from '@/gp/GroupAdminModel'
import Modal from '@/util/Modal.vue'
import UserItem from '@/manage/users/UserItem.vue'
import ProfileCard from '@/manage/ProfileCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupMemberRemoveModal',
  emits: [
  'ok',
],
  setup(__props, { expose: __expose, emit }) {

__expose({
  open,
  close,
})



const pmRef = ref<PotentialMember>()

const confirmMessageRef = computed(() => pmRef.value?.member 
  ? "Remove this user from the group?" 
  : "Remove this profile from the group?")

const modalElem = ref<InstanceType<typeof Modal>>()

function open(pm: PotentialMember) {
  pmRef.value = pm

  modalElem.value?.open()
}

function close() {
  modalElem.value?.close()
}

function onOk() {
  emit('ok', pmRef.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalElem",
    ref: modalElem,
    title: "Confirm remove",
    "ok-text": "Remove",
    "ok-style": "danger",
    "busy-text": "Removing...",
    onOk: onOk
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(confirmMessageRef.value), 1),
      (pmRef.value?.member)
        ? (_openBlock(), _createBlock(UserItem, {
            key: 0,
            "user-id": pmRef.value.member.userId
          }, null, 8, ["user-id"]))
        : (_openBlock(), _createBlock(ProfileCard, {
            key: 1,
            "person-id": pmRef.value?.profileGroup?.startItemId
          }, null, 8, ["person-id"])),
      (pmRef.value?.lastUserInvite?.result == _unref(InvitationResult).Pending)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " This profile has a pending invitation. Removing the profile will cancel the invitation. "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})